<template>
    <div class="card">
        <div class="card-body py-2 px-3">
            <div class="m-0 d-flex justify-content-between align-items-center">
                <a
                    :href="`https://${domain.domain}`"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="text-dark"
                    v-if="viewEditDomain"
                >{{ domain.domain }}</a>
                <div class="d-flex mb-1" v-else>
                    <input
                      class="inputDomain"
                      type="text"
                      :style="[domain.automatic == 1 ? {'width': '45%'} : {'width': '100%'}]"
                      v-model="domainHost"
                      @keyup="verifyDomain"
                    />
                    <input
                      class="inputDomain"
                      type="text"
                      :value="'.' + baseDomain"
                      style="width: 38%;"
                      v-show="domain.automatic == 1"
                      disabled
                    />
                </div>

                <div class="d-flex align-items-center">
                    <i
                        v-if="viewEditDomain"
                        v-show="domain.main_domain != 1 && domain.status == 'online' && domain.automatic != 1"
                        v-b-tooltip.hover
                        class="fal fa-star opacity-50"
                        title="Tornar principal"
                        @click="favoriteDomain(domain.id)">
                    </i>

                     <i
                        v-if="viewEditDomain"
                        v-show="domain.main_domain == 1"
                        v-b-tooltip.hover
                        class="fas fa-star pointer opacity-50 main-domain-icon"
                        title="Domínio principal">
                    </i>

                    <div v-show="domain.automatic == 1" class="ml-3">
                        <i
                          class="fal fa-pencil-alt pointer opacity-50"
                          v-if="viewEditDomain"
                          v-b-tooltip.hover
                          title="Editar domínio"
                          @click="editDomain">
                        </i>
                        <div class="d-flex align-items-center" v-else>
                            <i
                              class="fal fa-ban pointer opacity-50 mr-3"
                              v-b-tooltip.hover
                              title="Cancelar"
                              @click="viewEditDomain = !viewEditDomain">
                            </i>
                            <i
                              v-if="saveDomainView"
                              class="fal fa-check pointer opacity-50"
                              @click="saveEditDomain(domain.id)">
                            </i>
                        </div>
                    </div>

                    <i
                      class="fal fa-trash-alt pointer opacity-50 ml-3"
                      v-b-tooltip.hover
                      title="Excluir domínio"
                      v-if="domain.automatic != 1"
                      @click="removeDomainId(domain.id)">
                    </i>
                </div>
            </div>
            <p class="error-text mb-2"> {{errorMessage}} </p>
            <div>
                <span v-if="domain.status == 'online'">
                    <strong class="status-online">Online</strong>
                </span>

                <span v-else-if="domain.status == 'fetching'">
                    <strong class="status-fetching"><i class="fas fa-spinner fa-spin"></i></strong>
                </span>

                <span v-else-if="domain.status == 'loading'">
                    <strong class="status-loading">Aguardando propagação</strong>
                    <i
                      v-b-tooltip.hover
                      title="Após o cadastro do domínio, o mesmo pode demorar até 24 horas para ser publicado devido ao tempo de propagação do DNS."
                      class="question-color fas fa-question-circle">
                    </i>
                </span>

                <span v-else>
                    <strong class="status-offline">Offline</strong>
                    <i
                      v-b-tooltip.hover
                      title="Já se passaram 24 horas desde o cadastro do domínio e ainda não conseguimos validar. Verifique as configurações ou contate o suporte."
                      class="question-color fas fa-question-circle">
                    </i>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: "DomainCard",
    props:{
        domain: {
            type: Object,
            required: true
        },
        verifyAutomatic: {
            type: Boolean,
            default: true
        },
        errorMsgDomain: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            viewEditDomain:true,
            errorMessage: "",
            saveDomainView:false,
            domainHost: null,
        }
    },
    mounted() {
        /* Remove a categoria(ex: .ulisite.com) do dominio */
        this.domainHost = this.domain.domain.replace(this.baseDomain, '').replace('.', '');
    },
    computed: {
        /* Retorna o dominio base do site */
        ...mapState({ baseDomain: state => state.application.app_base_domain })
    },
    watch: {
        errorMsgDomain() {
            if (this.errorMsgDomain) {
                this.viewEditDomain = false
                this.errorMessage = this.errorMsgDomain;
            } else {
                this.errorMsgDomain = ''
                this.viewEditDomain = true
            }
        }
    },
    methods: {
        removeDomainId(domainId) {
            this.$emit("confirmDelete", domainId)
        },
        editDomain() {
            if (this.errorMessage) return null

            this.domain.domain = this.domainHost + '.' + this.baseDomain;
            this.viewEditDomain = !this.viewEditDomain
            this.saveDomainView = false;
        },
        verifyDomain() {
            /* Só permite letra e números no domínio */
            var regexp = /^[a-zA-Z0-9.]+$/

            this.errorMessage = ""
            if (!this.domainHost.match(regexp)) {
                this.errorMessage = "Somente letra e número são permitidos."
            }
            let domain = this.domain.domain.replace(this.baseDomain, '').replace('.', '');
            let domainValidate = this.domainHost
            this.saveDomainView = true
            if (domain === domainValidate) {
                this.saveDomainView = false
            }

            this.domainHost = this.domainHost.replace('.', '')
        },
        saveEditDomain(domainId) {
            if (this.errorMessage && this.errorMsgDomain) return null

            else if (!this.errorMsgDomain) {
                this.$emit("saveEdit", domainId, this.domainHost)
                return null
            }
            this.viewEditDomain = !this.viewEditDomain
            this.$emit("saveEdit", domainId, this.domainHost)
            return null
        },
        favoriteDomain(domainId) {
            this.$emit("favoriteDomain", domainId)
        }
    }
}
</script>

<style scoped>
.main-domain-icon {
    color:#F8BB02
}
.status-online {
    color: #AEE678;
    font-size: 0.62rem;
}
.status-fetching {
    color: #000000;
    font-size: 0.62rem;
}
.status-loading {
    color: #FFC76E;
    font-size: 0.62rem;
}
.status-offline {
    color: #F4B7B7;
    font-size: 0.62rem;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/DomainCard.vue